export default {
	// api请求地址
	baseUrl: 'https://b.zjyunjian.cn',
	// 图片域名
	imgDomain: 'https://b.zjyunjian.cn',
	// 前端域名
	webDomain: 'https://b.zjyunjian.cn/web',
	// 腾讯地图key
	mpKey: '',
	// 客服
	webSocket: 'wss/b.zjyunjian.cn/wws',
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500
}